import { combineReducers } from '@reduxjs/toolkit'
import logo from './logoSlice'
import name from './nameSlice'
import announcement from './announcementSlice'
import features from './featuresSlice'

const reducer = combineReducers({
    logo,
    name,
    announcement,
    features,
})

export default reducer
